/* istanbul ignore file */
import { Badge } from 'framework/ui/mui-builder';
import useIncidentService from 'domain/gpo/cockpit/incident/incidentService';
import { useAsyncValue } from 'framework/utils';
import { Box, Typography } from '@mui/material';

const IncidentsCount = () => {
  const { getTotalCount } = useIncidentService();

  const count = useAsyncValue(getTotalCount) as number | false;
  const color = count ? 'error' : 'success';

  return count || count === 0 ? (
    <Box display="flex" alignItems="center" mb={1}>
      <Typography>Incidents: </Typography>
      <Badge color={color}>{count}</Badge>
    </Box>
  ) : null;
};

export default IncidentsCount;
